// side effects
import "./css/form-validator.less";
import "./css/signature-pad.less";
import "./css/main.less";
import "./js/validate.polyfill";

// no side effects
import { SignatureInput } from "./js/signature-input";
import { FormValidator } from "./js/form-validator";

function validateRequired() {
  const validity = FormValidator.VALIDITY_STATE;
  const hasValue = !!this.value;
  validity.valid = hasValue;
  validity.valueMissing = !hasValue;
  return validity;
}

const termsContainer = document.getElementById("termsSignatureContainer");
const termsInput = document.getElementById("termsSignature");
const termsSignature =
  termsContainer && termsInput
    ? new SignatureInput(termsContainer, {
        validate: validateRequired,
        input: termsInput,
      })
    : null;

if (termsSignature) {
  termsSignature.render();
}

const duesContainer = document.getElementById("duesSignatureContainer");
const duesInput = document.getElementById("duesSignature");
const duesSignature =
  duesContainer && duesInput
    ? new SignatureInput(duesContainer, {
        validate: validateRequired,
        input: duesInput,
      })
    : null;

if (duesSignature) {
  duesSignature.render();
}

const pacContainer = document.getElementById("pacSignatureContainer");
const pacInput = document.getElementById("pacSignature");
const pacSignature =
  pacContainer && pacInput
    ? new SignatureInput(pacContainer, {
        input: pacInput,
      })
    : null;

if (pacSignature) {
  pacSignature.render();
}

const releaseContainer = document.getElementById("releaseSignatureContainer");
const releaseInput = document.getElementById("releaseSignature");
const releaseSignature =
releaseContainer && releaseInput
    ? new SignatureInput(releaseContainer, {
        input: releaseInput,
      })
    : null;

if (releaseSignature) {
  releaseSignature.render();
}

const form = document.querySelector("form");
const validatedForm = new FormValidator(form, {
  beforeSubmit: (validations, form) => {
    const customerId = document.getElementById("customerId") 
      ? document.getElementById("customerId").value : null;
    const emailValidation = validations.find((v) => v.input.id === "email");
    const phoneValidation = validations.find((v) => v.input.id === "phone");
    const cellPhoneValidation = validations.find((v) => v.input.id === "cellPhone");
    const hasEmail = !!emailValidation.input.value;
    const hasPhone = !!phoneValidation.input.value;
    const hasCellPhone = !!cellPhoneValidation.input.value;
    
    if (!hasEmail && ((!hasPhone && (!customerId || customerId !== "seiuwi"))|| (customerId === "seiuwi" && !hasCellPhone))) {
      const requiredWithErr = new Error(
        "Please provide an email address."
      );
      emailValidation.error = requiredWithErr;
      
      if (!hasPhone && (!customerId || customerId !== "seiuwi")) {
        phoneValidation.error = new Error(
          "Please provide a phone number."
        );
      }

      if (customerId === "seiuwi" && !hasCellPhone) {
        cellPhoneValidation.error = new Error(
          "Please provide cell phone number"
        );
      }

      
    }
  },
  afterSubmit: (error) => {
    if (!error) {
      if (termsSignature) {
        termsSignature.signature.clear();
      }
      if (duesSignature) {
        duesSignature.signature.clear();
      }
      if (pacSignature) {
        pacSignature.signature.clear();
      }
      if (releaseSignature) {
        releaseSignature.signature.clear();
      }
      if (duesInput) {
        duesInput.value = "";
      }
      if (pacInput) {
        pacInput.value = "";
      }
      if (termsInput) {
        termsInput.value = "";
      }
      if (releaseInput) {
        releaseInput.value = "";
      }
    }
  },
});
validatedForm.initialize();
